var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React from 'react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag, InputTag } from '../../Utils/AtomicTag';
import { CloseOutlined, ArrowDownOutlined, ArrowUpOutlined } from '@feb-team/legao-icons-react';
import Tag from '../Tag';
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.container = React.createRef();
        _this.isCompositionEnd = true;
        _this.handleClickOutside = function (e) {
            var _a;
            if (!((_a = _this.container.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                if (e.nativeEvent) {
                    e.nativeEvent.stopImmediatePropagation();
                }
                _this.close();
            }
        };
        _this.tagClick = function (deletionValue) {
            var selectedValue = _this.state.selectedValue;
            var nextSelectedValue = selectedValue.filter(function (value) { return value !== deletionValue; });
            _this.setState({
                selectedValue: nextSelectedValue,
            });
            _this.props.onClear(deletionValue);
            _this.props.onChange(nextSelectedValue);
        };
        /*
         * Option组件点击的回调事件，用于和父组件通信
         * */
        _this.optionClick = function (optionProps, e) {
            var selectedValue = _this.state.selectedValue;
            var value = optionProps.value;
            if (!optionProps.disabled) {
                if (_this.props.mode === 'multiple') {
                    if (Array.isArray(selectedValue)) {
                        var deletionIndex = selectedValue.indexOf(value);
                        // 删除操作
                        if (deletionIndex > -1) {
                            selectedValue.splice(deletionIndex, 1);
                            _this.setState({
                                selectedValue: __spread(selectedValue),
                            });
                            _this.props.onChange(__spread(selectedValue));
                        }
                        else {
                            _this.setState({
                                selectedValue: __spread(selectedValue, [value]),
                            });
                            _this.props.onChange(__spread(selectedValue, [value]));
                        }
                    }
                }
                else {
                    _this.setState({
                        selectedValue: value,
                    });
                    _this.props.onChange(value);
                }
            }
            if (_this.props.mode === 'multiple')
                return;
            _this.toggle(e);
        };
        /*
         * 筛选条件处理
         * */
        _this.conditionInput = function (e) {
            var val = e.currentTarget.value;
            if (e.target.isOnComposition) {
                return _this.setState({
                    condition: val,
                });
            }
            else {
                _this.setState({
                    condition: val,
                }, function () {
                    _this.props.onSearch(val);
                });
            }
        };
        /*
         * 多选和单选带输入框的 UI 打开事件
         * */
        _this.open = function () {
            _this.setState({
                isFocus: true,
            });
            if (_this.props.showSearch) {
                _this.setState({
                    inputFocus: true,
                    inputClass: 'open',
                });
            }
            else {
                _this.setState({
                    inputClass: 'open',
                });
            }
        };
        _this.close = function () {
            _this.setState({
                isFocus: false,
            });
            if (!_this.props.disabled) {
                if (_this.props.showSearch) {
                    _this.setState({
                        inputFocus: false,
                        inputClass: 'close',
                        condition: '',
                    });
                }
                else {
                    _this.setState({
                        inputClass: 'close',
                    });
                }
            }
        };
        _this.toggle = function (e) {
            e.stopPropagation();
            if (_this.props.disabled)
                return;
            _this.state.inputClass === 'open' ? _this.close() : _this.open(e);
        };
        _this.clear = function () {
            if (_this.props.mode === 'multiple') {
                _this.setState({
                    condition: '',
                    selectedValue: [],
                });
            }
            else {
                _this.setState({
                    condition: '',
                    selectedValue: '',
                });
            }
            _this.props.onClear();
        };
        _this.toggleWrap = function () {
            _this.setState({
                isWrapHover: !_this.state.isWrapHover,
            });
        };
        _this.state = {
            isWrapHover: false,
            condition: '',
            inputClass: props.disabled ? 'disable' : 'close',
            inputFocus: false,
            selectedValue: _this.props.value || _this.props.defaultValue,
            isFocus: false,
        };
        return _this;
    }
    Select.prototype.componentWillReceiveProps = function (nextProps) {
        var value = nextProps.value;
        if (Array.isArray(value) &&
            Array.isArray(this.props.value) &&
            (value.join() != this.props.value.join() || value.length != this.props.value.length)) {
            this.setState({
                selectedValue: value,
            });
        }
        else if (value != this.props.value) {
            this.setState({
                selectedValue: value,
            });
        }
    };
    Select.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleClickOutside);
    };
    Select.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClickOutside);
    };
    /*
     * 渲染合成后的Input
     * */
    Select.prototype.renderCompositedUI = function () {
        var _this = this;
        var inputSizeClass = [];
        var divSizeClass = [];
        var _a = this.state, selectedValue = _a.selectedValue, inputFocus = _a.inputFocus, condition = _a.condition;
        var _b = this.props, disabled = _b.disabled, placeholder = _b.placeholder, showSearch = _b.showSearch, mode = _b.mode, size = _b.size;
        if (size === 'normal') {
            inputSizeClass = ['h-px-32'];
            divSizeClass = ['min-w-px-100', 'h-px-32', 'leading-px-30', 'cursor-pointer'];
        }
        else if (size === 'small') {
            inputSizeClass = ['h-px-24', 'text-sm'];
            divSizeClass = ['min-w-px-100', 'h-px-24', 'leading-px-22', 'cursor-pointer'];
        }
        var inputClassName = __spread([
            'w-px-220'
        ], inputSizeClass, [
            'border-0',
            'float-left',
            'pl-px-8',
            'w-full',
        ]);
        var inputAutoClassName = __spread([
            'w-px-220'
        ], inputSizeClass, [
            'border-0',
            'float-left',
            'pl-px-8',
            'w-auto',
        ]);
        // 禁用的UI状态
        if (disabled) {
            if (mode === 'multiple') {
                return (React.createElement(DivTag, { onClick: this.toggle, atomics: divSizeClass, autoPrefixedClassName: "select-tag" },
                    Array.isArray(selectedValue) &&
                        selectedValue.map(function (item) {
                            if (item)
                                return React.createElement(Tag, { key: item }, item);
                            return null;
                        }),
                    React.createElement(InputTag, { type: "hidden", disabled: true, value: this.state.selectedValue })));
            }
            else {
                return (React.createElement(InputTag, { atomics: inputClassName, autoPrefixedClassName: "select-input", placeholder: placeholder, type: "text", value: selectedValue, disabled: true, autoComplete: "off" }));
            }
        }
        // 带搜索和多选的状态
        else if (showSearch && mode === 'multiple') {
            return (React.createElement(DivTag, { atomics: divSizeClass, autoPrefixedClassName: "select-tag" },
                React.createElement(DivTag, { atomics: ['h-px-32', 'float-left'] }, Array.isArray(selectedValue) &&
                    selectedValue.map(function (item) {
                        if (item) {
                            return (React.createElement(Tag, { key: item, close: true, onClose: function () {
                                    _this.tagClick(item);
                                } }, item));
                        }
                        else {
                            return null;
                        }
                    })),
                React.createElement(InputTag, { onClick: this.open, onChange: this.conditionInput, onCompositionStart: function (e) {
                        ;
                        e.target.isOnComposition = true;
                    }, onCompositionEnd: function (e) {
                        ;
                        e.target.isOnComposition = false;
                        _this.conditionInput(e);
                    }, atomics: inputAutoClassName, autoPrefixedClassName: "select-input", placeholder: Array.isArray(selectedValue) && selectedValue.length ? '' : placeholder, type: "text", value: condition, autoComplete: "off" }),
                React.createElement(InputTag, { type: "hidden", value: this.state.selectedValue })));
        }
        // 多选的状态
        else if (mode === 'multiple') {
            return (React.createElement(DivTag, { onClick: this.toggle, atomics: divSizeClass, autoPrefixedClassName: "select-tag" },
                Array.isArray(selectedValue) &&
                    selectedValue.map(function (item) {
                        if (item)
                            return (React.createElement(Tag, { key: item, close: true, onClose: function () {
                                    _this.tagClick(item);
                                } }, item));
                        return null;
                    }),
                React.createElement(InputTag, { type: "hidden", value: this.state.selectedValue })));
        }
        // 搜索
        else if (showSearch) {
            return (React.createElement(InputTag, { atomics: inputClassName, type: "text", autoComplete: "off", onClick: this.open, onChange: this.conditionInput, autoPrefixedClassName: "select-input", onCompositionStart: function (e) {
                    ;
                    e.target.isOnComposition = true;
                }, onCompositionEnd: function (e) {
                    ;
                    e.target.isOnComposition = false;
                    _this.conditionInput(e);
                }, placeholder: showSearch && inputFocus ? selectedValue.toString() : placeholder, value: showSearch && inputFocus ? condition : selectedValue }));
        }
        // 普通的，不能搜索
        return (React.createElement(InputTag, { atomics: inputClassName, type: "text", readOnly: true, autoPrefixedClassName: "select-input", autoComplete: "off", onClick: this.toggle, placeholder: placeholder, value: this.state.selectedValue }));
    };
    /*
     * 渲染子节点，这里完成了 Option 选中、禁用、筛选功能
     * */
    Select.prototype.renderChildren = function () {
        var _this = this;
        var _a = this.props, children = _a.children, filterOption = _a.filterOption, mode = _a.mode, notFoundContent = _a.notFoundContent;
        var _b = this.state, selectedValue = _b.selectedValue, condition = _b.condition;
        // 没有自元素
        if (!children)
            return null;
        var calcChildren = React.Children.map(children, function (childItem, index) {
            if (!childItem)
                return null;
            /*
             * 根据 Select 组件上的 filterOption 过滤器来筛选
             * */
            if (filterOption) {
                var filter = filterOption(condition, childItem);
                if (!filter) {
                    return null;
                }
            }
            var selected = false;
            // 多选的处理
            if (mode === 'multiple') {
                // 多选的话，defaultIndex 属性支持数组和非数组
                if (Array.isArray(selectedValue) &&
                    selectedValue.filter(function (value) { return value == childItem.props.value; }).length) {
                    selected = true;
                }
                else {
                    selected = selectedValue == childItem.props.value;
                }
            }
            else {
                // 单选的话，不支持数组
                if (Array.isArray(selectedValue)) {
                    console.warn('defaultIndex prop [%s] not valid.', selectedValue);
                }
                else {
                    selected = selectedValue == childItem.props.value;
                }
            }
            // 将点击事件等传给克隆的节点
            var attrForClone = __assign(__assign({}, childItem.props), { key: "select-option-" + index, onItemClick: _this.optionClick, selected: selected, itemIndex: index, keyCmd: childItem.key ? childItem.key : "select-option-" + index });
            return React.cloneElement(childItem, attrForClone);
        });
        // 返回 未找到
        var notFoundContentAtomics = [
            'leading-4',
            'text-sm',
            'p-3',
            'text-gray-400',
            'leading-3',
            'flex',
            'items-center',
            'justify-center',
        ];
        if (!calcChildren || (Array.isArray(calcChildren) && calcChildren.length === 0)) {
            return (React.createElement(DivTag, { atomics: notFoundContentAtomics, autoPrefixedClassName: "select-not-found" }, notFoundContent));
        }
        return calcChildren;
    };
    /*
     * 渲染 Option 组件列表
     * */
    Select.prototype.renderOptionList = function () {
        // 列表
        var itemWrapAtomics = ['w-full', 'bg-white', 'shadow'];
        return (React.createElement(DivTag, { atomics: itemWrapAtomics, autoPrefixedClassName: "select-bg" }, this.renderChildren()));
    };
    Select.prototype.renderIcon = function () {
        var _a = this.props, clear = _a.clear, mode = _a.mode, disabled = _a.disabled, size = _a.size;
        var _b = this.state, inputClass = _b.inputClass, isWrapHover = _b.isWrapHover, selectedValue = _b.selectedValue;
        var openedAtomics = [
            'w-4',
            'h-4',
            'text-sm',
            'fill-brand-400',
            'flex',
            'items-center',
            'justify-center',
        ];
        var closedAtomics = [
            'w-4',
            'h-4',
            'text-sm',
            'fill-gray-400',
            'flex',
            'items-center',
            'justify-center',
        ];
        var cursor = disabled ? '' : 'cursor-pointer';
        var spanAtomics = [
            'absolute',
            'flex',
            'items-center',
            'justify-center',
            'h-full',
            'top-0',
            'right-0',
            'h-4',
            'w-px-30',
            'leading-4',
            'mr-px-4',
            cursor,
        ];
        var smallSpanAtomics = [
            'absolute',
            'flex',
            'h-full',
            'items-center',
            'justify-center',
            'top-0',
            'right-0',
            'h-4',
            'w-px-30',
            'leading-4',
            'mr-px-4',
            cursor,
        ];
        var showClear;
        if (mode === 'multiple') {
            showClear = !!selectedValue.length;
        }
        else {
            showClear = !!selectedValue;
        }
        if (clear && showClear && isWrapHover && !disabled) {
            return (React.createElement(SpanTag, { onClick: this.clear, autoPrefixedClassName: "select-clear", atomics: size === 'normal' ? spanAtomics : smallSpanAtomics }, React.isValidElement(clear) ? (clear) : (React.createElement(SpanTag, { className: 'legao-select-close', atomics: ['w-4', 'h-4', 'text-sm', 'fill-gray-400'] },
                React.createElement(CloseOutlined, null)))));
        }
        else {
            return (React.createElement(SpanTag, { onClick: this.toggle, autoPrefixedClassName: "select-arrow", atomics: size === 'normal' ? spanAtomics : smallSpanAtomics }, inputClass === 'open' ? (React.createElement(ArrowUpOutlined, { className: "legao-select-arrow-up " + openedAtomics.join(' ') })) : (
            // <SpanTag className={'legao-select-arrow-up'} atomics={openedAtomics}>
            //   <ArrowUpOutlined />
            // </SpanTag>
            React.createElement(ArrowDownOutlined, { className: "legao-select-arrow-down " + closedAtomics.join(' ') })
            // <SpanTag className={'legao-select-arrow-down'} atomics={closedAtomics}>
            //   <ArrowDownOutlined />
            // </SpanTag>
            )));
        }
    };
    Select.prototype.render = function () {
        var _a = this.props, style = _a.style, className = _a.className, disabled = _a.disabled, size = _a.size, mode = _a.mode, showSearch = _a.showSearch;
        var _b = this.state, isWrapHover = _b.isWrapHover, inputClass = _b.inputClass, isFocus = _b.isFocus;
        var selectContrClass = '';
        if (!disabled && mode == 'single') {
            selectContrClass = 'select-pointer';
        }
        else if (!disabled && mode === 'multiple' && !showSearch) {
            selectContrClass = 'select-pointer';
        }
        else if (!disabled && mode === 'multiple' && showSearch) {
            selectContrClass = 'select-text';
        }
        if (isFocus) {
            selectContrClass += ' shadow-input';
        }
        return (React.createElement(DivTag, { name: Select.NAME, ref: this.container, atomics: [
                'inline-block',
                size,
                (isWrapHover && !disabled ? 'focus' : ''),
                inputClass,
            ], style: style, className: "Select " + className, onMouseEnter: this.toggleWrap, onMouseLeave: this.toggleWrap },
            React.createElement(DivTag, { className: "rounded  " + selectContrClass, atomics: [
                    'relative',
                    'border',
                    'border-gray-300',
                    'inline-block',
                    'pr-px-30',
                    'overflow-hidden',
                ], autoPrefixedClassName: "select-control" },
                this.renderCompositedUI(),
                this.renderIcon()),
            this.renderOptionList()));
    };
    Select.defaultProps = defaultProps;
    Select.NAME = 'select';
    Select.displayName = 'Select';
    return Select;
}(React.Component));
export { Select };
